// Shared public presentation rules. This module has no admin or network dependencies.
export const HONGGUO_BOARDS = [
  { key: 'hot-drama', label: '综合榜' },
  { key: 'hot-real-drama', label: '真人剧' },
  { key: 'hot-ai-drama', label: 'AI剧' },
  { key: 'hot-comic-drama', label: '漫剧' },
];

const cleanText = value => typeof value === 'string' && value.trim() ? value.trim() : null;
export const rankingPageKey = (board, page) => `${board}:${page}`;
export const rankingSourceUrl = board => `https://hongguoduanju.com/rank/${board}`;
export const rankingMetric = value => cleanText(value) || '—';
export const rankingDetailUrl = seriesId => typeof seriesId === 'string' && /^\d{1,30}$/.test(seriesId)
  ? `https://hongguoduanju.com/detail?series_id=${seriesId}` : null;

const COVER_HOSTS = new Set(['p3-novel.byteimg.com', 'p6-novel.byteimg.com']);
export const rankingCoverUrl = value => {
  if (typeof value !== 'string' || value.length > 4096 || /[\s\\]/.test(value)
    || [...value].some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && COVER_HOSTS.has(url.hostname) && !url.username && !url.password
      && !url.port && !url.hash && url.pathname.startsWith('/novel-pic/') ? url.href : null;
  } catch { return null; }
};

export const rankingTime = value => {
  if (!value) return '未提供';
  const time = new Date(value);
  return Number.isNaN(time.getTime()) ? '未提供' : time.toLocaleString('zh-CN', { hour12: false });
};

export const searchRankingPage = (items, query) => {
  const needle = query.trim().toLocaleLowerCase();
  return needle ? items.filter(row => row.title.toLocaleLowerCase().includes(needle) || row.seriesId.includes(needle)) : items;
};

export const normalizeReaderRankingSnapshot = (data, board, page) => {
  if (!HONGGUO_BOARDS.some(item => item.key === board) || !Number.isInteger(page) || page < 1 || page > 5
    || !data || data.board !== board || data.page !== page || !['READY', 'EMPTY'].includes(data.status)
    || !Array.isArray(data.items)) {
    throw new Error('榜单数据与当前分类或页码不匹配，请重试加载。');
  }
  // Build every external link from validated identifiers, never trust a returned href.
  return {
    board, boardLabel: HONGGUO_BOARDS.find(item => item.key === board).label,
    page, pageSize: 20, totalPages: 5, status: data.status,
    sourceUrl: `${rankingSourceUrl(board)}${page > 1 ? `?page=${page}` : ''}`,
    sourceUpdatedText: cleanText(data.sourceUpdatedText),
    fetchedAt: cleanText(data.fetchedAt),
    items: data.status === 'EMPTY' ? [] : data.items.slice(0, 20).filter(row => row && typeof row === 'object').map(row => ({
      rank: Number.isInteger(row.rank) && row.rank > 0 && row.rank <= 100 ? row.rank : null,
      // A numeric ID may already have lost precision; do not coerce it back to a string.
      seriesId: typeof row.seriesId === 'string' ? row.seriesId : '',
      title: cleanText(row.title) || '未提供剧名',
      heatText: cleanText(row.heatText), scoreText: cleanText(row.scoreText),
      favoriteText: cleanText(row.favoriteText), likeText: cleanText(row.likeText),
      tags: Array.isArray(row.tags) ? row.tags.map(cleanText).filter(Boolean).slice(0, 6) : [],
      detailUrl: rankingDetailUrl(row.seriesId), coverUrl: rankingCoverUrl(row.coverUrl),
    })),
  };
};
